module.exports = __webpack_public_path__ + "img/indarjoko.15e7d2d0.jpeg";